











import Vue from "vue";
import Component from "vue-class-component";

@Component({
  name: "ApplyCardWrapper",
  components: {},
})
export default class extends Vue {}
